<div class="preloader" [hidden]="!loading">
    <div class="spinner"></div>
</div>
<div class='container-fluit'>
    <div class="row" style="background-color: #fff;">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-sm-12 div1">
            <div class="spinner-border spinner-border-sm" role="status" [hidden]="!loading">
            </div>
            <div [hidden]="loading">
                <div>متاسفانه چنین کاربری وجود ندارد</div>
            </div>
        </div>
    </div><!-- row -->
</div><!-- container-fluit -->